module.exports = __webpack_public_path__ + "img/neon.f1970778.png";